const errorCode = [
  5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5099, 5100, 5101, 5102, 5103, 5104, 5105,
  5106, 5120, 5121, 5122, 5123, 5124, 5125, 5126, 5130, 5131, 5132, 5133, 5140, 5141, 5142, 5150, 5151, 5152, 5153,
  5154, 5993, 5994, 5995, 5996, 5997, 5998, 5999, 6401,
];

const errorMessage = {
  5000: 'ERROR_MSG_SERIAL_NUMBER_NOT_EXIST',
  5001: 'ERROR_MSG_INVALID_DATE_FORMAT',
  5002: 'ERROR_MSG_START_TIME_CANNO_BE_LATER_THAN_END_TIME',
  5003: 'ERROR_MSG_BOOKING_STATUS_NOT_EXISTS_OR_INVALID',
  5004: 'ERROR_MSG_INVALID_DATE_TIME_FORMAT',
  5005: 'ERROR_MSG_START_TIME_CANNOT_BE_LATER_THAN',
  5006: 'ERROR_MSG_RELATIONSHIP_CODE_NOT_FOUND',
  5007: 'ERROR_MSG_INVALID_ROBOT_STATUS',
  5008: 'ERROR_MSG_INVALID_ZOOM_ACCOUNT',
  5009: 'ERROR_MSG_SERIAL_NUMBER_IS_DUPLICATED',
  5010: 'ERROR_MSG_INVALID_ROBOT_NAME',
  5011: 'ERROR_MSG_CANCEL_REASON_NOT_EXISTS_OR_INVALID',
  5099: 'ERROR_MSG_ILLEGAL_ARGUMENT_FOR_REQUEST',
  5100: 'ERROR_MSG_BOOKING_ID_DOES_NOT_EXIST',
  5101: 'ERROR_MSG_THIS_TIMESLOT_IS_ALREADY_BOOKED',
  5102: 'ERROR_MSG_OVER_MAX_QUOTA',
  5103: 'ERROR_MSG_TIMESLOT_UNAVAILABLE',
  5104: 'ERROR_MSG_ZOOM_MEETING_MAXIMUM_LIMIT',
  5105: 'ERROR_MSG_ROBOT_IS_NOT_EXISTS',
  5106: 'ERROR_MSG_ROBOT_IS_UNAVAILABLE',
  5120: 'ERROR_MSG_BOOKING_IS_IN_PROGRESS',
  5121: 'ERROR_MSG_BOOKING_IS_EXPIRED',
  5122: 'ERROR_MSG_BOOKING_NOT_FOUND',
  5123: 'ERROR_MSG_NOT_BELONG_TO_THAT_HAGO_USER',
  5124: 'ERROR_MSG_USER_HAVE_EXISTING_BOOKING_RECORD',
  5125: 'ERROR_MSG_THE_BOOKING_CAN_UPDATE',
  5126: 'ERROR_MSG_THE_BOOKING_CAN_CANCEL',
  5130: 'ERROR_MSG_THIS_BOOKING_DAY_HAS_BEEN_RELEASED',
  5131: 'ERROR_MSG_SERVICE_HOURS_IS_NOT_EXISTS',
  5132: 'ERROR_MSG_SERVICE_HOURS_CONFLICT',
  5133: 'ERROR_MSG_SERVICE_HOUR_HAVE_BOOKING',
  5140: 'ERROR_MSG_UNAVAILABLE_TIMESLOT_DO_NOT_EXIST',
  5141: 'ERROR_MSG_TIMESLOT_HAVE_ALREADY_BOOKED',
  5142: 'ERROR_MSG_TIMESLOT_HAS_BEEN_PASSED',
  5150: 'ERROR_MSG_ZOOM_ACCOUNT_IS_NOT_EXIST',
  5151: 'ERROR_MSG_THIS_ZOOM_ACCOUNT_CAN_NOT_BE_DELETED',
  5152: 'ERROR_MSG_THIS_ZOOM_ACCOUNT_CAN_NOT_BE_UPDATED',
  5153: 'ERROR_MSG_COULD_NOT_FIND_ANY_ACTIVE_CREATE_BOOKING',
  5154: 'ERROR_MSG_ZOOM_ACCOUNT_IS_DUPLICATED_IN_THE_SYSTEM',
  5155: 'ERROR_MSG_COULD_NOE_FIND_ANY_ACTIVE_ZOOM_ACCOUNT_TO_DEL_BOOKING',
  5993: 'ERROR_MSG_INVALID_ACCESS_TOKEN',
  5994: 'ERROR_MSG_USER_HAS_NOT_BEEN_ACTIVATED',
  5995: 'ERROR_MSG_USER_DOES_NOT_EXIST',
  5996: 'ERROR_MSG_CONCURRENT_ACCESS',
  5997: 'ERROR_MSG_ROLE_HAS_NO_ACCESS_AUTHORITY',
  5998: 'ERROR_MSG_API_DOES_NOT_EXIST',
  5999: 'ERROR_MSG_SERVER_BUSY_OR_SYSTEM_ERROR',
  6401: 'ERROR_MSG_VERSION_MISMATCH',
};
export default { errorCode, errorMessage };
